<template>
  <div>
    <Navbar type="bg-transparent-sticky" />
    <div class="hero-container-thin">
      <div class="hero-opacity" />
      <img class="hero-image" src="../assets/gdq_hero.jpg" alt="hero image" />
    </div>
    <Breadcrumb />
    <div class="border-0 mx-auto container-xl">
      <div class="title-area">
        <h1 class="page-title h2 mb-2">Admin materials</h1>
      </div>
      <input
        v-model="search"
        type="search"
        placeholder="Search"
        class="form-control mb-3"
        @keyup="adminmaterials_get"
      />
      <BaseTable
        id="materials"
        hover
        :items="materials"
        :fields="fields"
        :busy="loading"
        :sort-by="orderby"
        :sort-desc="orderdesc"
        :no-local-sorting="true"
        @sort-changed="materials_sort"
        @row-clicked="showmaterial"
      >
        <template v-slot:cell(material_heading)="data">
          <template v-if="data.item && data.item.material_extension">
            <fa-icon
              v-if="
                data.item.material_extension === 'doc' ||
                data.item.material_extension === 'docx'
              "
              icon="file-word"
            />
            <fa-icon
              v-if="
                data.item.material_extension === 'xls' ||
                data.item.material_extension === 'xlsx'
              "
              icon="file-excel"
            />
            <fa-icon
              v-if="
                data.item.material_extension === 'ppt' ||
                data.item.material_extension === 'pptx'
              "
              icon="file-powerpoint"
            />
            <fa-icon
              v-if="data.item.material_extension === 'pdf'"
              icon="file-pdf"
            />
            {{ data.item.material_heading }}
          </template>
        </template>
        <template v-slot:cell(actions)="data">
          <div class="d-flex justify-content-end">
            <BaseDropdown right class="ml-2">
              <template #button-content>
                <i class="fa-solid fa-ellipsis"></i>
              </template>
              <a class="dropdown-item" @click.prevent="showmaterial(data.item)">
                Download
              </a>
            </BaseDropdown>
          </div>
        </template>
      </BaseTable>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import { useStore } from "vuex";
import Navbar from "./Navbar.vue";
import { config } from "../../config";
import Breadcrumb from "./Breadcrumb.vue";
import BaseTable from "./base/BaseTable.vue";
import BaseDropdown from "./base/BaseDropdown.vue";

export default {
  name: "AdminMaterials",
  components: {
    Navbar,
    Breadcrumb,
    BaseTable,
    BaseDropdown,
  },
  setup() {
    // Reactive data
    const fields = [
      { key: "material_heading", label: "Heading", sortable: true },
      {
        key: "material_date",
        label: "Latest update",
        sortable: true,
        tdClass: "text-left",
        thClass: "text-left",
      },
      { key: "actions", label: "Actions", class: "ellipsis-button" },
    ];

    const store = useStore();

    const materials = ref([]);
    const usergroupId = ref(2);
    const loading = ref(false);
    const currentPage = ref(1);
    const perPage = ref(999999);
    const orderby = ref("material_heading");
    const orderdesc = ref(false);
    const search = ref("");

    // Methods
    const formatDate = (date) => {
      const d = new Date(date);
      const year = d.getFullYear();
      if (Number.isNaN(year)) {
        return "";
      }
      let month = "" + (d.getMonth() + 1);
      let day = "" + d.getDate();
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return [year, month, day].join("-");
    };

    const showmaterial = (item) => {
      const reporturl = config.report_url + "/gdq_materials.php?r=" + item.id;
      const downloadURL = new URL(reporturl);
      const downloadLink = document.createElement("a");
      downloadLink.href = downloadURL;
      downloadLink.setAttribute(
        "download",
        "GDQ_Material_" + item.id + "." + item.material_extension
      );
      document.body.appendChild(downloadLink);
      downloadLink.click();
    };

    const adminmaterials_get = () => {
      loading.value = true;
      let filter;
      if (search.value !== "") {
        filter = {
          material_heading: {
            operator: "LIKE",
            value: "%" + search.value + "%",
          },
        };
      } else {
        filter = {
          id: {
            operator: " > ",
            value: 0,
          },
        };
      }
      if (Number(usergroupId.value) !== 0) {
        filter.material_usergroup_id = {
          operator: "=",
          value: usergroupId.value,
        };
      }
      store
        .dispatch("materials_fetch", {
          start: currentPage.value - 1,
          limit: perPage.value,
          orderby: orderby.value,
          order: orderdesc.value === false ? "ASC" : "DESC",
          filter,
          usergroup_id: usergroupId.value,
        })
        .then((resp) => {
          const mapped = resp.data.result.map((item) => ({
            id: item.id,
            material_heading: item.material_heading,
            material_date: formatDate(item.material_date),
            material_extension: (item.material_extension || "").toLowerCase(),
          }));
          materials.value = mapped;
        })
        .finally(() => {
          loading.value = false;
        });
    };

    const materials_sort = ({ sortBy, sortDesc } = {}) => {
      if (sortBy) {
        orderby.value = sortBy;
      }
      if (typeof sortDesc === "boolean") {
        orderdesc.value = sortDesc;
      }
      adminmaterials_get();
    };

    // Lifecycle hook
    onMounted(() => {
      adminmaterials_get();
    });

    return {
      // Reactive data
      fields,
      materials,
      usergroupId,
      loading,
      currentPage,
      perPage,
      orderby,
      orderdesc,
      search,

      // Methods
      formatDate,
      showmaterial,
      adminmaterials_get,
      materials_sort,
    };
  },
};
</script>

<style></style>
